import '.cp{position:relative;}.ssr-plugin'
import '.it{width:64px;}.ssr-plugin'
import '.iu{height:64px;}.ssr-plugin'
import '.e{flex-shrink:0;}.ssr-plugin'
import '.bt{position:absolute;}.ssr-plugin'
import '.iv{bottom:-4px;}.ssr-plugin'
import '.ct{right:-4px;}.ssr-plugin'
import '.ex{border-radius:50%;}.ssr-plugin'
import '.iw{border:2px solid var(--palette-white);}.ssr-plugin'
import '.c{overflow:hidden;}.ssr-plugin'
import '.ix{width:32px;}.ssr-plugin'
import '.iy{height:32px;}.ssr-plugin'
import { styled } from 'inlines'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { Image } from '@app/components/core/image/Image'

type ConversationAvatarProps = {
  initiativeImage?: string
  userAvatar?: string
  userName: string
}

export const ConversationAvatar = ({
  initiativeImage,
  userAvatar,
  userName,
}: ConversationAvatarProps) => {
  return (
    <div className="cp it iu e"
    >
      {initiativeImage ? (
        <Image
          src={initiativeImage}
          resizeWidth={128}
          alt="initiative"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: '12px',
          }}
        />
      ) : (
        <Avatar
          size="medium"
          shape="square"
          labelSource={userName}
          variant="yellow"
        />
      )}
      <div className="bt iv ct ex iw c ix iy"
      >
        <Avatar
          size="extra-small"
          shape="circle"
          image={userAvatar}
          labelSource={userName}
        />
      </div>
    </div>
  )
}
